module.exports = __webpack_public_path__ + "img/Bodice-Front-B7-Da-Ea.01c52b5e.png";